import * as React from "react";
import i18next from "i18next";
import { usePrintContext } from "../../Contexts/PrintContext";

export const PrintResult = (): JSX.Element => {
    const { loading, printUrl } = usePrintContext();

    return (
        <div className="print-result unselectable">
            <div>{i18next.t("print.exportFile")}</div>
            <div className="info-text small">
                {loading ? <Loading /> : null}
                {printUrl ? <PrintUrl printUrl={printUrl} /> : null}
                {!loading && !printUrl ? <div>{i18next.t("print.exportedPrintLocation")}</div> : null}
            </div>
        </div>
    );
};

const Loading = () => (
    <div className="print-result-file">
        <a target="_blank" className="print-url">
            <div className="spinner-small" />
            <span className="result-info">{i18next.t("print.exportPrepare")}</span>
        </a>
    </div>
);

const PrintUrl = ({ printUrl }: { printUrl: string }) =>
    printUrl === "error" ? (
        <div>{i18next.t("print.error")}</div>
    ) : (
        <div className="print-result-file">
            <a target="_blank" rel="noopener noreferrer" className="print-url" href={printUrl}>
                <div className="icon-geolite-sync-data-down" />
                <span className="result-info">{i18next.t("print.openPrint")}</span>
            </a>
        </div>
    );
